export default class PartAmount {
    constructor(part) {
        this.partPrice = 0;
        this.partAmount = 0;
        this.partId = part.objectId;
        this.part = part;
    }
}